import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'popup-cmp',
  templateUrl: './popup.component.html',
})
export class PopupComponent implements OnInit {
  @Input('message') message = '';
  @Input() isOk: boolean = false;
  @Input() isDelete: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() loadingMessage: string = '';

  @Output('action') action = new EventEmitter<string>();

  constructor() {}

  ngOnInit(): void {}

  onOkClick() {
    this.action.emit('ok');
  }

  onCancelClick() {
    this.action.emit('cancel');
  }

  onDeleteClick() {
    this.action.emit('delete');
  }
}
